export const create = {
  form: {
    name: 'Name',
    manufacturer: 'Manufacturer',
    supplier: 'Supplier',
    price: 'Price',
    inventory: 'Inventory',
    addNew: 'Add New',
    requireName: 'Please input name',
    requireManufacture: 'Please input manufacture name',
    requireSupplier: 'Please input supplier name',
    requirePrice: 'Please input price',
    requireInventory: 'Please input inventory',
  },
  pageHeader: {
    title: 'New Washing Machine Part',
    back: 'Back',
  },
}
